/**
 * Utility for generating consistent session IDs for Site Evaluation
 * 
 * NOTE: Session ID management has been moved to Redux.
 * Use selectActionPlanSessionId selector from siteEvalRedirectSlice instead.
 * This utility is kept only for the session ID generation logic.
 */

/**
 * Generate a unique session ID for site evaluation
 * Format: site_eval_{timestamp}_{random_string}
 * @returns {string} Unique session ID
 */
export const generateSiteEvalSessionId = (): string => {
  const randomString = Math.random().toString(36).substr(2, 9);
  const sessionId = `site_eval_${Date.now()}_${randomString}`;
  console.log('[generateSiteEvalSessionId] Generated session ID:', sessionId);
  return sessionId;
};

/**
 * @deprecated Use Redux selectActionPlanSessionId selector instead
 * Get or create a site evaluation session ID
 * This function is deprecated - session IDs are now managed in Redux.
 */
export const getOrCreateSiteEvalSessionId = (): string => {
  console.warn('[getOrCreateSiteEvalSessionId] DEPRECATED: Use Redux for session ID management');
  return generateSiteEvalSessionId();
};

/**
 * @deprecated Session IDs are now managed in Redux
 * Clear the site evaluation session ID
 * Use clearSiteEvalActionPlans action from siteEvalRedirectSlice instead.
 */
export const clearSiteEvalSessionId = (): void => {
  console.warn('[clearSiteEvalSessionId] DEPRECATED: Use Redux clearSiteEvalActionPlans action instead');
};
